// extracted by mini-css-extract-plugin
module.exports = {"emoBullet":"home_emoBullet__3h77O","starEmo":"home_starEmo__3ieB3"};